var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgenda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "agenda_svg__cls-1",
    d: "M165.05 72.33c6.59 0 11.95-5.8 11.95-12.93V38.75c0-7.13-5.36-12.93-11.95-12.93h-4.9A18.51 18.51 0 00142 10.75H50a18.52 18.52 0 00-18.5 18.5v12.59h-5.42a6.5 6.5 0 000 13h5.38v20.22h-5.38a6.5 6.5 0 000 13h5.38V106h-5.38a6.5 6.5 0 000 13h5.38v19h-5.38a6.5 6.5 0 000 13h5.38v12.58A18.52 18.52 0 0050 182.12h92a18.51 18.51 0 0018.28-15.81h4.79c6.59 0 11.95-5.8 11.95-12.93v-20.66c0-7.13-5.36-12.93-11.95-12.93h-4.57v-.47h4.57c6.59 0 11.95-5.8 11.95-12.93V85.73c0-7.12-5.36-12.92-11.95-12.92h-4.57v-.48zm-1.05-13h-3.52V38.82H164zm-16.52 104.29a5.5 5.5 0 01-5.5 5.5H74.33v-86a6.5 6.5 0 00-13 0v86H50a5.51 5.51 0 01-5.5-5.5V151h4.66a6.5 6.5 0 100-13h-4.7v-19h4.66a6.5 6.5 0 000-13h-4.66V88.06h4.66a6.5 6.5 0 100-13h-4.66V54.84h4.66a6.5 6.5 0 100-13h-4.66V29.25a5.51 5.51 0 015.5-5.5h11.37v37.49a6.5 6.5 0 1013 0V23.75H142a5.5 5.5 0 015.5 5.5zM164 132.79v20.52h-3.52v-20.52zm0-47v20.51h-3.52V85.81z"
  })));
}

export default SvgAgenda;